import http from '@/api/http'
import { createApiError, parseApiResponse } from '@/api/parseApiResponse'

export async function protectedRequest(request) {
  try {
    const response = await request()
    return parseApiResponse(response)
  } catch (error) {
    if (error?.response) {
      throw createApiError(error.response)
    }
    throw error
  }
}
